import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { RoleEntityPermissionMap } from 'ag-common-lib/public-api';
import { hasPermissionGuard } from 'ag-common-svc/shared/utils/has-permission-guard';
import { map, tap } from 'rxjs';
import { ARMAuthService } from '../shared/services/util/arm-auth.service';
import { REPORTS_VIEWER_PERMISSIONS, REPORTS_VIEWER_ROUTE_PERMISSION } from './reports-viewer-permissions';

@Injectable({ providedIn: 'root' })
export class ReportsViewerGuard implements CanActivate {
  constructor(
    private readonly authService: ARMAuthService,
    private readonly router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const configuredPath = route.routeConfig?.path ?? '';
    const routeKey = configuredPath.startsWith(':') ? route.paramMap.get('reportId') : configuredPath.split('/')[0];
    const permission = routeKey ? REPORTS_VIEWER_ROUTE_PERMISSION[routeKey] : undefined;
    const isViewerRoot = configuredPath === '' || configuredPath === 'reports-viewer';
    const requiredPermissions = permission ? [permission] : isViewerRoot ? REPORTS_VIEWER_PERMISSIONS : [];

    return this.authService.armPermissions$.pipe(
      map((permissions: RoleEntityPermissionMap) => hasPermissionGuard(requiredPermissions, permissions)),
      tap(hasPermission => {
        if (!hasPermission) {
          void this.router.navigate(['/access-denied']);
        }
      }),
    );
  }
}
